export default "__VITE_ASSET__CxTFAE7D__"